import type { CorridorBufferPathInput, CorridorBufferPathResult } from './compute-corridor-buffers-sync.js'
import { computeCorridorBuffersSync } from './compute-corridor-buffers-sync.js'
import { runInGeoWorker } from '../workers/geo-worker-runtime.js'

/**
 * Vue / reactive stores may wrap coordinates in Proxies; structured clone (postMessage / Comlink) cannot transfer them.
 */
function cloneCorridorPathInputsForWorker(paths: CorridorBufferPathInput[]): CorridorBufferPathInput[] {
  return paths.map((it) => ({
    pathId: it.pathId,
    qualityPercent: it.qualityPercent,
    radiusMeters: it.radiusMeters,
    raw: it.raw.map((c) => [Number(c[0]), Number(c[1])] as [number, number]),
  }))
}

/**
 * Public API: corridor geometry via worker when possible, else {@link computeCorridorBuffersSync} on main.
 */
export async function computeCorridorBuffers(
  paths: CorridorBufferPathInput[]
): Promise<CorridorBufferPathResult[]> {
  if (paths.length === 0) return []
  return runInGeoWorker({
    method: 'computeCorridorBuffers',
    payload: paths,
    cloneForWorker: cloneCorridorPathInputsForWorker,
    onMainThread: computeCorridorBuffersSync,
    debugDetail: `${paths.length} path(s)`,
  })
}
